var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5V6.9675C3.00099 6.31338 3.26128 5.68634 3.72381 5.22381C4.18634 4.76128 4.81338 4.50099 5.4675 4.5H18.5325C19.1866 4.50099 19.8137 4.76128 20.2762 5.22381C20.7387 5.68634 20.999 6.31338 21 6.9675V15.5325C20.999 16.1866 20.7387 16.8137 20.2762 17.2762C19.8137 17.7387 19.1866 17.999 18.5325 18H6L3 19.5Z",
    stroke: "#31B7A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H18",
    stroke: "#31B7A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5H18",
    stroke: "#31B7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0c4eb56b549dce69c7b8cba2532c3b06.svg";
export { ForwardRef as ReactComponent };